import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { NO_PARTNER_CODE } from '../helpers/metadataInterceptor';
import { PartnerConfigService } from '../services/partner-config.service';

export const partnerCodeInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const partnerConfigService = inject(PartnerConfigService);
    const partnerCode = partnerConfigService.config()?.partnerCode;
    if (partnerCode && !req.context.get(NO_PARTNER_CODE)) {
        req = req.clone({ setHeaders: { 'Partner-Code': partnerCode } });
    }

    return next(req);
};
